export const data =
{
  "lat": 41.0092,
  "lon": 28.9662,
  "timezone": "Europe/Istanbul",
  "timezone_offset": 10800,
  "current": {
    "dt": 1660988296,
    "sunrise": 1660965524,
    "sunset": 1661014607,
    "temp": 301.06,
    "feels_like": 303.52,
    "pressure": 1010,
    "humidity": 69,
    "dew_point": 294.85,
    "uvi": 8.11,
    "clouds": 75,
    "visibility": 10000,
    "wind_speed": 3.09,
    "wind_deg": 250,
    "weather": [
      {
        "id": 803,
        "main": "Clouds",
        "description": "broken clouds",
        "icon": "04d"
      }
    ]
  },
  "minutely": [
    { "dt": 1660988340, "precipitation": 0 },
    { "dt": 1660988400, "precipitation": 0 },
    { "dt": 1660988460, "precipitation": 0 },
    { "dt": 1660988520, "precipitation": 0 },
    { "dt": 1660988580, "precipitation": 0 },
    { "dt": 1660988640, "precipitation": 0 },
    { "dt": 1660988700, "precipitation": 0 },
    { "dt": 1660988760, "precipitation": 0 },
    { "dt": 1660988820, "precipitation": 0 },
    { "dt": 1660988880, "precipitation": 0 },
    { "dt": 1660988940, "precipitation": 0 },
    { "dt": 1660989000, "precipitation": 0 },
    { "dt": 1660989060, "precipitation": 0 },
    { "dt": 1660989120, "precipitation": 0 },
    { "dt": 1660989180, "precipitation": 0 },
    { "dt": 1660989240, "precipitation": 0 },
    { "dt": 1660989300, "precipitation": 0 },
    { "dt": 1660989360, "precipitation": 0 },
    { "dt": 1660989420, "precipitation": 0 },
    { "dt": 1660989480, "precipitation": 0 },
    { "dt": 1660989540, "precipitation": 0 },
    { "dt": 1660989600, "precipitation": 0 },
    { "dt": 1660989660, "precipitation": 0 },
    { "dt": 1660989720, "precipitation": 0 },
    { "dt": 1660989780, "precipitation": 0 },
    { "dt": 1660989840, "precipitation": 0 },
    { "dt": 1660989900, "precipitation": 0 },
    { "dt": 1660989960, "precipitation": 0 },
    { "dt": 1660990020, "precipitation": 0 },
    { "dt": 1660990080, "precipitation": 0 },
    { "dt": 1660990140, "precipitation": 0 },
    { "dt": 1660990200, "precipitation": 0 },
    { "dt": 1660990260, "precipitation": 0 },
    { "dt": 1660990320, "precipitation": 0 },
    { "dt": 1660990380, "precipitation": 0 },
    { "dt": 1660990440, "precipitation": 0 },
    { "dt": 1660990500, "precipitation": 0 },
    { "dt": 1660990560, "precipitation": 0 },
    { "dt": 1660990620, "precipitation": 0 },
    { "dt": 1660990680, "precipitation": 0 },
    { "dt": 1660990740, "precipitation": 0 },
    { "dt": 1660990800, "precipitation": 0 },
    { "dt": 1660990860, "precipitation": 0 },
    { "dt": 1660990920, "precipitation": 0 },
    { "dt": 1660990980, "precipitation": 0 },
    { "dt": 1660991040, "precipitation": 0 },
    { "dt": 1660991100, "precipitation": 0 },
    { "dt": 1660991160, "precipitation": 0 },
    { "dt": 1660991220, "precipitation": 0 },
    { "dt": 1660991280, "precipitation": 0 },
    { "dt": 1660991340, "precipitation": 0 },
    { "dt": 1660991400, "precipitation": 0 },
    { "dt": 1660991460, "precipitation": 0 },
    { "dt": 1660991520, "precipitation": 0 },
    { "dt": 1660991580, "precipitation": 0 },
    { "dt": 1660991640, "precipitation": 0 },
    { "dt": 1660991700, "precipitation": 0 },
    { "dt": 1660991760, "precipitation": 0 },
    { "dt": 1660991820, "precipitation": 0 },
    { "dt": 1660991880, "precipitation": 0 },
    { "dt": 1660991940, "precipitation": 0 }
  ],
  "hourly": [
    {
      "dt": 1660986000,
      "temp": 301.09,
      "feels_like": 303.2,
      "pressure": 1010,
      "humidity": 66,
      "dew_point": 294.15,
      "uvi": 7.43,
      "clouds": 60,
      "visibility": 10000,
      "wind_speed": 1.5,
      "wind_deg": 86,
      "wind_gust": 3.38,
      "weather": [
        {
          "id": 803,
          "main": "Clouds",
          "description": "broken clouds",
          "icon": "04d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1660989600,
      "temp": 301.06,
      "feels_like": 303.52,
      "pressure": 1010,
      "humidity": 69,
      "dew_point": 294.85,
      "uvi": 8.11,
      "clouds": 75,
      "visibility": 10000,
      "wind_speed": 1.35,
      "wind_deg": 42,
      "wind_gust": 2.8,
      "weather": [
        {
          "id": 803,
          "main": "Clouds",
          "description": "broken clouds",
          "icon": "04d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1660993200,
      "temp": 301.33,
      "feels_like": 303.49,
      "pressure": 1010,
      "humidity": 65,
      "dew_point": 294.13,
      "uvi": 7.63,
      "clouds": 60,
      "visibility": 10000,
      "wind_speed": 2.26,
      "wind_deg": 15,
      "wind_gust": 3.04,
      "weather": [
        {
          "id": 803,
          "main": "Clouds",
          "description": "broken clouds",
          "icon": "04d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1660996800,
      "temp": 301.82,
      "feels_like": 303.64,
      "pressure": 1009,
      "humidity": 60,
      "dew_point": 293.29,
      "uvi": 6.16,
      "clouds": 45,
      "visibility": 10000,
      "wind_speed": 3.69,
      "wind_deg": 12,
      "wind_gust": 4.15,
      "weather": [
        {
          "id": 802,
          "main": "Clouds",
          "description": "scattered clouds",
          "icon": "03d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661000400,
      "temp": 302.28,
      "feels_like": 303.65,
      "pressure": 1009,
      "humidity": 55,
      "dew_point": 292.32,
      "uvi": 4.13,
      "clouds": 30,
      "visibility": 10000,
      "wind_speed": 5.71,
      "wind_deg": 24,
      "wind_gust": 6.03,
      "weather": [
        {
          "id": 802,
          "main": "Clouds",
          "description": "scattered clouds",
          "icon": "03d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661004000,
      "temp": 301.89,
      "feels_like": 302.83,
      "pressure": 1008,
      "humidity": 53,
      "dew_point": 291.37,
      "uvi": 2.23,
      "clouds": 15,
      "visibility": 10000,
      "wind_speed": 5.6,
      "wind_deg": 30,
      "wind_gust": 6.44,
      "weather": [
        {
          "id": 801,
          "main": "Clouds",
          "description": "few clouds",
          "icon": "02d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661007600,
      "temp": 301.29,
      "feels_like": 302.15,
      "pressure": 1007,
      "humidity": 54,
      "dew_point": 291.13,
      "uvi": 0.87,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 5.81,
      "wind_deg": 42,
      "wind_gust": 6.91,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661011200,
      "temp": 300.23,
      "feels_like": 301.26,
      "pressure": 1007,
      "humidity": 59,
      "dew_point": 291.64,
      "uvi": 0.21,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 5.87,
      "wind_deg": 50,
      "wind_gust": 7.49,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661014800,
      "temp": 299.22,
      "feels_like": 299.22,
      "pressure": 1007,
      "humidity": 65,
      "dew_point": 292.23,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 5.77,
      "wind_deg": 56,
      "wind_gust": 8.02,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661018400,
      "temp": 298.72,
      "feels_like": 299.13,
      "pressure": 1008,
      "humidity": 69,
      "dew_point": 292.52,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 5.64,
      "wind_deg": 62,
      "wind_gust": 8.33,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661022000,
      "temp": 298.27,
      "feels_like": 298.72,
      "pressure": 1007,
      "humidity": 72,
      "dew_point": 292.84,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 5.72,
      "wind_deg": 69,
      "wind_gust": 8.6,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661025600,
      "temp": 298,
      "feels_like": 298.47,
      "pressure": 1007,
      "humidity": 74,
      "dew_point": 292.94,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 5.13,
      "wind_deg": 70,
      "wind_gust": 8.1,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661029200,
      "temp": 297.71,
      "feels_like": 298.18,
      "pressure": 1007,
      "humidity": 75,
      "dew_point": 293.04,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4.8,
      "wind_deg": 69,
      "wind_gust": 7.88,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661032800,
      "temp": 297.47,
      "feels_like": 297.97,
      "pressure": 1007,
      "humidity": 77,
      "dew_point": 293.19,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4.56,
      "wind_deg": 61,
      "wind_gust": 7.8,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661036400,
      "temp": 297.32,
      "feels_like": 297.83,
      "pressure": 1007,
      "humidity": 78,
      "dew_point": 293.29,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4.26,
      "wind_deg": 64,
      "wind_gust": 7.7,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661040000,
      "temp": 297.09,
      "feels_like": 297.63,
      "pressure": 1007,
      "humidity": 80,
      "dew_point": 293.48,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4,
      "wind_deg": 59,
      "wind_gust": 7.62,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661043600,
      "temp": 297,
      "feels_like": 297.56,
      "pressure": 1006,
      "humidity": 81,
      "dew_point": 293.47,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 3.67,
      "wind_deg": 56,
      "wind_gust": 7.62,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661047200,
      "temp": 296.91,
      "feels_like": 297.46,
      "pressure": 1006,
      "humidity": 81,
      "dew_point": 293.47,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 3.32,
      "wind_deg": 59,
      "wind_gust": 7.45,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661050800,
      "temp": 296.73,
      "feels_like": 297.28,
      "pressure": 1006,
      "humidity": 82,
      "dew_point": 293.47,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 3.25,
      "wind_deg": 59,
      "wind_gust": 7.22,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661054400,
      "temp": 296.75,
      "feels_like": 297.31,
      "pressure": 1006,
      "humidity": 82,
      "dew_point": 293.45,
      "uvi": 0.14,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 3.36,
      "wind_deg": 57,
      "wind_gust": 7.15,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661058000,
      "temp": 297.62,
      "feels_like": 298.16,
      "pressure": 1006,
      "humidity": 78,
      "dew_point": 293.44,
      "uvi": 0.67,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4.01,
      "wind_deg": 54,
      "wind_gust": 7.04,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661061600,
      "temp": 298.94,
      "feels_like": 299.4,
      "pressure": 1006,
      "humidity": 70,
      "dew_point": 293.02,
      "uvi": 1.84,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4.5,
      "wind_deg": 56,
      "wind_gust": 6.31,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661065200,
      "temp": 300.2,
      "feels_like": 301.44,
      "pressure": 1006,
      "humidity": 62,
      "dew_point": 292.27,
      "uvi": 3.61,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4.54,
      "wind_deg": 54,
      "wind_gust": 6.24,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661068800,
      "temp": 301.17,
      "feels_like": 302.41,
      "pressure": 1006,
      "humidity": 58,
      "dew_point": 291.97,
      "uvi": 5.59,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4.73,
      "wind_deg": 48,
      "wind_gust": 6.15,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661072400,
      "temp": 301.91,
      "feels_like": 302.98,
      "pressure": 1006,
      "humidity": 54,
      "dew_point": 291.77,
      "uvi": 7.16,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 5.19,
      "wind_deg": 43,
      "wind_gust": 6.33,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661076000,
      "temp": 302.54,
      "feels_like": 303.61,
      "pressure": 1005,
      "humidity": 52,
      "dew_point": 291.56,
      "uvi": 7.78,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 5.69,
      "wind_deg": 38,
      "wind_gust": 6.51,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661079600,
      "temp": 302.78,
      "feels_like": 303.81,
      "pressure": 1005,
      "humidity": 51,
      "dew_point": 291.45,
      "uvi": 7.32,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 6.07,
      "wind_deg": 34,
      "wind_gust": 6.71,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661083200,
      "temp": 302.71,
      "feels_like": 303.71,
      "pressure": 1005,
      "humidity": 51,
      "dew_point": 291.45,
      "uvi": 5.9,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 6.2,
      "wind_deg": 33,
      "wind_gust": 7.07,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661086800,
      "temp": 302.43,
      "feels_like": 303.45,
      "pressure": 1004,
      "humidity": 52,
      "dew_point": 291.65,
      "uvi": 3.95,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 6.42,
      "wind_deg": 34,
      "wind_gust": 7.53,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661090400,
      "temp": 301.87,
      "feels_like": 302.92,
      "pressure": 1004,
      "humidity": 54,
      "dew_point": 291.81,
      "uvi": 2.12,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 6.57,
      "wind_deg": 35,
      "wind_gust": 7.88,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661094000,
      "temp": 301.11,
      "feels_like": 302.33,
      "pressure": 1004,
      "humidity": 58,
      "dew_point": 292.12,
      "uvi": 0.83,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 6.57,
      "wind_deg": 37,
      "wind_gust": 8.2,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661097600,
      "temp": 300.05,
      "feels_like": 301.39,
      "pressure": 1004,
      "humidity": 64,
      "dew_point": 292.65,
      "uvi": 0.2,
      "clouds": 1,
      "visibility": 10000,
      "wind_speed": 6.45,
      "wind_deg": 44,
      "wind_gust": 8.58,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661101200,
      "temp": 299.03,
      "feels_like": 299.53,
      "pressure": 1004,
      "humidity": 71,
      "dew_point": 293.41,
      "uvi": 0,
      "clouds": 2,
      "visibility": 10000,
      "wind_speed": 6.11,
      "wind_deg": 48,
      "wind_gust": 8.68,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661104800,
      "temp": 298.63,
      "feels_like": 299.19,
      "pressure": 1004,
      "humidity": 75,
      "dew_point": 293.93,
      "uvi": 0,
      "clouds": 2,
      "visibility": 10000,
      "wind_speed": 5.75,
      "wind_deg": 52,
      "wind_gust": 8.58,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661108400,
      "temp": 298.4,
      "feels_like": 298.99,
      "pressure": 1004,
      "humidity": 77,
      "dew_point": 293.95,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 5.38,
      "wind_deg": 56,
      "wind_gust": 8.24,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661112000,
      "temp": 298.18,
      "feels_like": 298.78,
      "pressure": 1004,
      "humidity": 78,
      "dew_point": 294.05,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4.8,
      "wind_deg": 58,
      "wind_gust": 7.84,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661115600,
      "temp": 298.06,
      "feels_like": 298.67,
      "pressure": 1004,
      "humidity": 79,
      "dew_point": 294.11,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4.32,
      "wind_deg": 55,
      "wind_gust": 7.44,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661119200,
      "temp": 297.87,
      "feels_like": 298.49,
      "pressure": 1004,
      "humidity": 80,
      "dew_point": 294.08,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 4.15,
      "wind_deg": 61,
      "wind_gust": 7.63,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661122800,
      "temp": 297.67,
      "feels_like": 298.27,
      "pressure": 1004,
      "humidity": 80,
      "dew_point": 294.03,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 3.85,
      "wind_deg": 58,
      "wind_gust": 7.43,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661126400,
      "temp": 297.42,
      "feels_like": 298.04,
      "pressure": 1004,
      "humidity": 82,
      "dew_point": 294.17,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 3.82,
      "wind_deg": 59,
      "wind_gust": 7.55,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661130000,
      "temp": 297.24,
      "feels_like": 297.9,
      "pressure": 1004,
      "humidity": 84,
      "dew_point": 294.44,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 3.35,
      "wind_deg": 56,
      "wind_gust": 7.25,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661133600,
      "temp": 297.15,
      "feels_like": 297.85,
      "pressure": 1004,
      "humidity": 86,
      "dew_point": 294.55,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 3.3,
      "wind_deg": 49,
      "wind_gust": 7.06,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661137200,
      "temp": 297.06,
      "feels_like": 297.75,
      "pressure": 1004,
      "humidity": 86,
      "dew_point": 294.62,
      "uvi": 0,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 3.34,
      "wind_deg": 50,
      "wind_gust": 7.35,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01n"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661140800,
      "temp": 297.14,
      "feels_like": 297.81,
      "pressure": 1005,
      "humidity": 85,
      "dew_point": 294.52,
      "uvi": 0.13,
      "clouds": 0,
      "visibility": 10000,
      "wind_speed": 3.28,
      "wind_deg": 48,
      "wind_gust": 7.32,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661144400,
      "temp": 297.98,
      "feels_like": 298.63,
      "pressure": 1005,
      "humidity": 81,
      "dew_point": 294.45,
      "uvi": 0.65,
      "clouds": 1,
      "visibility": 10000,
      "wind_speed": 4.09,
      "wind_deg": 55,
      "wind_gust": 7.04,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661148000,
      "temp": 299.24,
      "feels_like": 299.24,
      "pressure": 1005,
      "humidity": 72,
      "dew_point": 293.73,
      "uvi": 1.81,
      "clouds": 1,
      "visibility": 10000,
      "wind_speed": 4.52,
      "wind_deg": 60,
      "wind_gust": 6.35,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661151600,
      "temp": 300.53,
      "feels_like": 302.08,
      "pressure": 1005,
      "humidity": 64,
      "dew_point": 293.18,
      "uvi": 3.5,
      "clouds": 11,
      "visibility": 10000,
      "wind_speed": 4.26,
      "wind_deg": 58,
      "wind_gust": 5.86,
      "weather": [
        {
          "id": 801,
          "main": "Clouds",
          "description": "few clouds",
          "icon": "02d"
        }
      ],
      "pop": 0
    },
    {
      "dt": 1661155200,
      "temp": 301.61,
      "feels_like": 303.17,
      "pressure": 1005,
      "humidity": 59,
      "dew_point": 292.87,
      "uvi": 5.41,
      "clouds": 19,
      "visibility": 10000,
      "wind_speed": 4.2,
      "wind_deg": 54,
      "wind_gust": 5.67,
      "weather": [
        {
          "id": 801,
          "main": "Clouds",
          "description": "few clouds",
          "icon": "02d"
        }
      ],
      "pop": 0
    }
  ],
  "daily": [
    {
      "dt": 1660989600,
      "sunrise": 1660965524,
      "sunset": 1661014607,
      "moonrise": 0,
      "moonset": 1660998120,
      "moon_phase": 0.79,
      "temp": {
        "day": 301.06,
        "min": 296.82,
        "max": 302.28,
        "night": 298,
        "eve": 300.23,
        "morn": 296.82
      },
      "feels_like": {
        "day": 303.52,
        "night": 298.47,
        "eve": 301.26,
        "morn": 297.28
      },
      "pressure": 1010,
      "humidity": 69,
      "dew_point": 294.85,
      "wind_speed": 5.87,
      "wind_deg": 50,
      "wind_gust": 8.6,
      "weather": [
        {
          "id": 803,
          "main": "Clouds",
          "description": "broken clouds",
          "icon": "04d"
        }
      ],
      "clouds": 75,
      "pop": 0,
      "uvi": 8.11
    },
    {
      "dt": 1661076000,
      "sunrise": 1661051984,
      "sunset": 1661100919,
      "moonrise": 1661031120,
      "moonset": 1661088060,
      "moon_phase": 0.82,
      "temp": {
        "day": 302.54,
        "min": 296.73,
        "max": 302.78,
        "night": 298.18,
        "eve": 300.05,
        "morn": 296.75
      },
      "feels_like": {
        "day": 303.61,
        "night": 298.78,
        "eve": 301.39,
        "morn": 297.31
      },
      "pressure": 1005,
      "humidity": 52,
      "dew_point": 291.56,
      "wind_speed": 6.57,
      "wind_deg": 35,
      "wind_gust": 8.68,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "clouds": 0,
      "pop": 0,
      "uvi": 7.78
    },
    {
      "dt": 1661162400,
      "sunrise": 1661138445,
      "sunset": 1661187230,
      "moonrise": 1661120100,
      "moonset": 1661177760,
      "moon_phase": 0.85,
      "temp": {
        "day": 303.04,
        "min": 297.06,
        "max": 303.5,
        "night": 299,
        "eve": 300.7,
        "morn": 297.14
      },
      "feels_like": {
        "day": 304.52,
        "night": 299.7,
        "eve": 302.55,
        "morn": 297.81
      },
      "pressure": 1005,
      "humidity": 53,
      "dew_point": 292.55,
      "wind_speed": 7.45,
      "wind_deg": 37,
      "wind_gust": 9.51,
      "weather": [
        {
          "id": 500,
          "main": "Rain",
          "description": "light rain",
          "icon": "10d"
        }
      ],
      "clouds": 37,
      "pop": 0.23,
      "rain": 0.37,
      "uvi": 7.73
    },
    {
      "dt": 1661248800,
      "sunrise": 1661224905,
      "sunset": 1661273539,
      "moonrise": 1661209440,
      "moonset": 1661266980,
      "moon_phase": 0.88,
      "temp": {
        "day": 301.47,
        "min": 297.6,
        "max": 303.16,
        "night": 300.06,
        "eve": 302.37,
        "morn": 297.6
      },
      "feels_like": {
        "day": 303.34,
        "night": 301.85,
        "eve": 304.24,
        "morn": 298.4
      },
      "pressure": 1008,
      "humidity": 62,
      "dew_point": 293.1,
      "wind_speed": 5.54,
      "wind_deg": 45,
      "wind_gust": 7.24,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "clouds": 7,
      "pop": 0.22,
      "uvi": 7.84
    },
    {
      "dt": 1661335200,
      "sunrise": 1661311365,
      "sunset": 1661359848,
      "moonrise": 1661299260,
      "moonset": 1661355840,
      "moon_phase": 0.91,
      "temp": {
        "day": 302.67,
        "min": 297.98,
        "max": 303.62,
        "night": 299.79,
        "eve": 301.06,
        "morn": 297.98
      },
      "feels_like": {
        "day": 304.25,
        "night": 299.79,
        "eve": 303.15,
        "morn": 298.71
      },
      "pressure": 1009,
      "humidity": 55,
      "dew_point": 292.79,
      "wind_speed": 5.88,
      "wind_deg": 43,
      "wind_gust": 8.5,
      "weather": [
        {
          "id": 500,
          "main": "Rain",
          "description": "light rain",
          "icon": "10d"
        }
      ],
      "clouds": 13,
      "pop": 0.63,
      "rain": 1.04,
      "uvi": 7.13
    },
    {
      "dt": 1661421600,
      "sunrise": 1661397825,
      "sunset": 1661446156,
      "moonrise": 1661389260,
      "moonset": 1661444340,
      "moon_phase": 0.94,
      "temp": {
        "day": 301.07,
        "min": 297.26,
        "max": 302.26,
        "night": 299.74,
        "eve": 301.53,
        "morn": 297.26
      },
      "feels_like": {
        "day": 301.87,
        "night": 299.74,
        "eve": 303.18,
        "morn": 297.42
      },
      "pressure": 1009,
      "humidity": 54,
      "dew_point": 290.41,
      "wind_speed": 5.11,
      "wind_deg": 17,
      "wind_gust": 6.22,
      "weather": [
        {
          "id": 500,
          "main": "Rain",
          "description": "light rain",
          "icon": "10d"
        }
      ],
      "clouds": 0,
      "pop": 0.24,
      "rain": 0.2,
      "uvi": 8
    },
    {
      "dt": 1661508000,
      "sunrise": 1661484285,
      "sunset": 1661532464,
      "moonrise": 1661479440,
      "moonset": 1661532480,
      "moon_phase": 0.97,
      "temp": {
        "day": 301.09,
        "min": 297.54,
        "max": 302.53,
        "night": 301.24,
        "eve": 302.53,
        "morn": 297.54
      },
      "feels_like": {
        "day": 302.73,
        "night": 301.52,
        "eve": 303.18,
        "morn": 298.23
      },
      "pressure": 1009,
      "humidity": 62,
      "dew_point": 292.37,
      "wind_speed": 2.93,
      "wind_deg": 201,
      "wind_gust": 3.56,
      "weather": [
        {
          "id": 500,
          "main": "Rain",
          "description": "light rain",
          "icon": "10d"
        }
      ],
      "clouds": 90,
      "pop": 0.35,
      "rain": 0.18,
      "uvi": 8
    },
    {
      "dt": 1661594400,
      "sunrise": 1661570745,
      "sunset": 1661618770,
      "moonrise": 1661569680,
      "moonset": 1661620380,
      "moon_phase": 0,
      "temp": {
        "day": 302.77,
        "min": 298.51,
        "max": 304.67,
        "night": 300.7,
        "eve": 304.4,
        "morn": 298.51
      },
      "feels_like": {
        "day": 302.98,
        "night": 301.11,
        "eve": 303.7,
        "morn": 298.77
      },
      "pressure": 1011,
      "humidity": 45,
      "dew_point": 288.37,
      "wind_speed": 5.69,
      "wind_deg": 39,
      "wind_gust": 7.39,
      "weather": [
        {
          "id": 800,
          "main": "Clear",
          "description": "clear sky",
          "icon": "01d"
        }
      ],
      "clouds": 0,
      "pop": 0,
      "uvi": 8
    }
  ]
}
